export default __webpack_public_path__ + "static/media/interview.fcece589.svg";